document.addEventListener('DOMContentLoaded', function () {
  let openMainMenu = null;

  const handleMenuOpening = (detailsElement, isSubMenu = false) => {
    if (!isSubMenu) {
      if (openMainMenu && openMainMenu !== detailsElement) {
        openMainMenu.removeAttribute('open');
      }
      detailsElement.setAttribute('open', '');
      openMainMenu = detailsElement;
    } else {
      detailsElement.setAttribute('open', '');
    }
  };

  const mainMenuDetails = document.querySelectorAll('.header__inline-menu > ul > li > header-menu > details');
  mainMenuDetails.forEach(detailsElement => {
    const summaryElement = detailsElement.querySelector('summary');

    // Add hover behavior for styling
    summaryElement.addEventListener('mouseenter', function () {
      handleMenuOpening(detailsElement);

      // Apply hover styles
      summaryElement.style.color = '#1f1f21'; // Highlight text color
      summaryElement.style.backgroundColor = '#ffffff'; // Highlight background
    });

    summaryElement.addEventListener('mouseleave', function () {
      // Remove hover styles
      summaryElement.style.color = ''; // Reset to default
      summaryElement.style.backgroundColor = ''; // Reset to default
    });

    detailsElement.addEventListener('mouseleave', function () {
      setTimeout(() => {
        if (!detailsElement.matches(':hover')) {
          detailsElement.removeAttribute('open');
          if (openMainMenu === detailsElement) {
            openMainMenu = null;
          }
        }
      }, 1000); // Delay in ms
    });
  });

  const submenuDetails = document.querySelectorAll('.header__submenu details');
  submenuDetails.forEach(detailsElement => {
    const summaryElement = detailsElement.querySelector('summary');

    summaryElement.addEventListener('mouseenter', function (event) {
      event.stopPropagation();
      handleMenuOpening(detailsElement, true);

      // Apply hover styles
      summaryElement.style.color = '#E3FC02'; // Highlight text color
      summaryElement.style.backgroundColor = '#1F1F21'; // Highlight background
    });

    summaryElement.addEventListener('mouseleave', function () {
      // Remove hover styles
      summaryElement.style.color = ''; // Reset to default
      summaryElement.style.backgroundColor = ''; // Reset to default
    });

    detailsElement.addEventListener('mouseleave', function () {
      setTimeout(() => {
        if (!detailsElement.matches(':hover')) {
          detailsElement.removeAttribute('open');
        }
      }, 1000); // Adjust delay as needed
    });
  });
});
